import {CMSContentType} from "../CMSType";
import {BaseListContentParams, BaseListContent} from "./list.abstract.content";
import {AContentDTO} from "../base.content";
import {LiveImage, LiveImageDTO, ILiveImageDTO} from "../../image";
import {BaseListImage} from "./base.content";

export interface GalleryContentItemDTO extends ILiveImageDTO {
  thumbnail: string;
}

export class GalleryContentItemParams extends LiveImageDTO {
  thumbnail: string;
  constructor(data: GalleryContentItemDTO) {
    super(data);
    this.thumbnail = data.thumbnail;
  }
}

export class GalleryContentItem extends BaseListImage {
  public thumbnail: string;

  constructor(data: GalleryContentItemParams) {
    super(data);
    this.thumbnail = data.thumbnail;
  }
  setOriginal(data: GalleryContentItemDTO) {
    super.setOriginal(data);
    this.thumbnail = data.thumbnail;
  }
}

export interface GalleryContentParams extends BaseListContentParams<GalleryContentItem> {
  label?: string;
}

export interface GalleryContentDTO extends AContentDTO {
  label?: string;
  items?: GalleryContentItemDTO[];
}

export class GalleryContent extends BaseListContent<GalleryContentItem> {
  readonly label: string;

  constructor(data: GalleryContentParams = {}) {
    super(CMSContentType.gallery, data);
    this.label = data.label;
  }

  updateLabel(label: string): this {
    return this._merge({label});
  }
}



// WEBPACK FOOTER //
// ./src/api/club-cms/content/gallery.content.ts